// extracted by mini-css-extract-plugin
module.exports = {"pastedFoilsList":"PastedFoilsList_pastedFoilsList__3IMx8","pastedFoilsItem":"PastedFoilsList_pastedFoilsItem__3orTa","pastedFoilCheck":"PastedFoilsList_pastedFoilCheck__3RWuJ"};